import React from "react"
import cls from "classnames"
import { Link } from "gatsby"
import * as styles from "./index.module.scss"
import LinkModule from "@/components/link-module"

const FreeTryOut: React.FC = () => {
  return (
    <div className={cls("container", styles.freeTryOut)}>
      <h3>体验全新的一栈式实时 HTAP 数据库</h3>
      <Link className="button is-primary is-medium" to="/product#SelectProduct">
        免费试用
      </Link>
      <div className={styles.link}>
        <LinkModule to="/product">查看 TiDB 产品详情</LinkModule>
      </div>
    </div>
  )
}

export default FreeTryOut
